import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="link"
export default class extends Controller {

  // aタグで post するだけ
  postForm(event) {
    let form = document.createElement('form');
    form.action = event.currentTarget.href;
    form.method = 'post';

    // CSRF検証を通すため authenticity_token を付与する
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const tokenField = document.createElement('input');
      tokenField.type = 'hidden';
      tokenField.name = 'authenticity_token';
      tokenField.value = csrfToken;
      form.appendChild(tokenField);
    }

    document.body.appendChild(form);
    form.submit();
  }
}
